module.exports = __webpack_public_path__ + "img/dashboard.30ef8c3a.svg";